import React, { useState } from "react";
import { Mail } from "lucide-react";
import { Button } from "@/src/components/ui/button.tsx";

const NewsletterSignup = () => {
    const [email, setEmail] = useState("");
    // const [status, setStatus] = useState(""); // "success", "error", or ""


    return (
        <div className="bg-neutral-900 rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
                <Mail className="h-6 w-6 text-white" />
                <h2 className="font-bold text-lg">WEEKLY NEWSLETTER</h2>
            </div>

            <p className="text-gray-300 mb-4">
                Stay updated with the latest mixes, Promo Tracks, label releases and interviews. Join our weekly newsletter for exclusive content and updates.
            </p>

            <form
                action="https://dreamchimney.us1.list-manage.com/subscribe/post?u=1e53bd25098a1c1b4a3a67215&amp;id=b097fdbc82"
                method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank"
                noValidate>
                <div className="flex gap-2">
                    <input
                        type="email"
                        name="EMAIL"
                        id="mce-EMAIL"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        className="flex-1 px-4 py-2 bg-neutral-800 border border-neutral-700 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                    <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                        <input type="text" name="b_1e53bd25098a1c1b4a3a67215_b097fdbc82" tabIndex="-1" value="" />
                    </div>
                    <Button
                        type="submit"
                        name="subscribe"
                        id="mc-embedded-subscribe"
                        className="bg-blue-600 hover:bg-blue-700 text-white px-6"
                    >
                        Subscribe
                    </Button>
                </div>


            </form>

            <p className="text-xs text-gray-400 mt-4">
                Your email address is not shared or spammed. Newsletter is sent every Monday.
            </p>
        </div>
    );
};

export default NewsletterSignup; 